/* istanbul ignore file */
export * from './SearchAdServerIntegration';
